import ControlledSelect from "../../Components/Select/ControlledSelect";
import Select from "../../Components/Select";
import React from "react";
import useFilteredList from "../../Hooks/UseFilteredList";
import {useTranslation} from "react-i18next";

type Props = {
    control: any;
    name: string
}
export const FeeReceiverSelect = ({control, name}: Props) => {

    const { t } = useTranslation();
    
    const [ filteredReceivers, setFilteredReceivers ] = useFilteredList(['AnotherSolution', 'Beatdown', 'Project', 'ThirdParty'], x => [x]);
    
    return (
        <ControlledSelect control={control} placeholder={t('receiver')} name={name} onFilter={setFilteredReceivers}>
            {filteredReceivers?.map((receiver, index) => <Select.Option key={index} value={receiver} label={receiver}/>)}
        </ControlledSelect>
    )
    
    
}